module.exports = __webpack_public_path__ + "static/media/instagram.302ab313.png";